module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-10-zoom.305bb2fc.png";